import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Spinner } from "@/components/kit";
import Shell from "@/components/Shell";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Lanes from "@/pages/Lanes";
import Sessions from "@/pages/Sessions";
import Vehicles from "@/pages/Vehicles";
import Payments from "@/pages/Payments";
import Barriers from "@/pages/Barriers";
import Devices from "@/pages/Devices";
import Checks from "@/pages/Checks";
import Exceptions from "@/pages/Exceptions";
import Watchlist from "@/pages/Watchlist";
import Reconciliation from "@/pages/Reconciliation";
import Reports from "@/pages/Reports";
import Audit from "@/pages/Audit";
import Users from "@/pages/Users";
import Branches from "@/pages/Branches";
import Settings from "@/pages/Settings";
import Attendant from "@/pages/Attendant";
import Portal from "@/pages/Portal";

document.documentElement.classList.toggle("dark", localStorage.getItem("pc_theme") !== "light");

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <Spinner />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/portal" element={<Portal />} />
      <Route path="/portal/:code" element={<Portal />} />
      <Route element={<Protected><Shell /></Protected>}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/lanes" element={<Lanes />} />
        <Route path="/sessions" element={<Sessions />} />
        <Route path="/vehicles" element={<Vehicles />} />
        <Route path="/payments" element={<Payments />} />
        <Route path="/barriers" element={<Barriers />} />
        <Route path="/devices" element={<Devices />} />
        <Route path="/checks" element={<Checks />} />
        <Route path="/exceptions" element={<Exceptions />} />
        <Route path="/watchlist" element={<Watchlist />} />
        <Route path="/reconciliation" element={<Reconciliation />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/audit" element={<Audit />} />
        <Route path="/users" element={<Users />} />
        <Route path="/branches" element={<Branches />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/attendant" element={<Attendant />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}
